import {Disclosure} from '@headlessui/react';
import React, {ReactNode} from 'react';

type CollapsibleNotificationsPanelProps = {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
};

export default function CollapsibleNotificationsPanel({
  title,
  children,
  defaultOpen = true,
}: CollapsibleNotificationsPanelProps) {
  return (
    <Disclosure as="div" defaultOpen={defaultOpen}>
      {({open}) => (
        <>
          <Disclosure.Button
            className={`w-full flex justify-between items-center px-4 py-3 bg-gray-50 hover:bg-gray-100 text-left font-medium text-gray-700 border border-gray-200 ${
              open ? 'rounded-t-md' : 'rounded-md'
            }`}
          >
            <span className="font-medium">{title}</span>
            <svg
              className={`w-5 h-5 text-gray-500 transition-transform ${
                open ? 'transform rotate-180' : ''
              }`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </Disclosure.Button>
          <Disclosure.Panel className="border-x border-b border-gray-200 rounded-b-md">
            {children}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
